import { SERVICE_DATA, TESTIMONIAL_DATA } from "@/lib/data";
import { Component } from "@builder.io/sdk";

export const awardsTestimonialsConfig: Component = {
  name: "Awards Testimonials",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "awards-testimonials",
      helperText:
        "Unique identifier for the section. Useful for linking to the section by '#id'.",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "Recognized Excellence in Home Care Services",
      required: true,
    },
    {
      name: "subheading",
      type: "string",
      defaultValue: "What Families and Caregivers are Saying About Care Indeed",
      required: true,
    },
    {
      name: "description",
      type: "longText",
      defaultValue:
        "We are proud to be trusted by families and facilities in Campbell. Read their stories to see how Care Indeed makes a difference every day.",
      required: true,
    },
    {
      name: "showSecondaryCTA",
      type: "boolean",
      defaultValue: false,
      friendlyName: "Show Secondary Button",
      helperText: "Do you want to show the secondary button?",
    },
    {
      name: "secondaryCta",
      friendlyName: "Secondary Button",
      type: "object",
      showIf: "options.get('showSecondaryCTA') === true",
      subFields: [
        {
          name: "text",
          type: "string",
          required: true,
        },
        {
          name: "href",
          type: "string",
          required: true,
        },
      ],
    },
    {
      name: "data",
      type: "list",
      subFields: [
        {
          name: "count",
          type: "number",
          required: true,
        },
        {
          name: "label",
          type: "string",
          required: true,
        },
      ],
      defaultValue: SERVICE_DATA,
    },
    {
      name: "overrideLogos",
      type: "boolean",
      defaultValue: false,
    },
    {
      name: "logos",
      type: "list",
      showIf: "options.get('overrideLogos') === true",
      subFields: [
        {
          name: "src",
          type: "file",
          allowedFileTypes: ["jpeg", "png"],
          required: true,
        },
        {
          name: "alt",
          type: "string",
          required: true,
        },
      ],
    },
    {
      name: "testimonials",
      type: "list",
      subFields: [
        {
          name: "stars",
          type: "number",
          min: 1,
          max: 5,
          required: true,
        },
        {
          name: "name",
          type: "string",
          required: true,
        },
        {
          name: "date",
          type: "string",
          required: true,
        },
        {
          name: "text",
          type: "longText",
          required: true,
        },
        {
          name: "imageURL",
          friendlyName: "Avatar Image",
          type: "file",
          allowedFileTypes: ["jpeg", "png"],
          required: true,
          helperText: "Upload an avatar image for the testimonial",
        },
      ],
      defaultValue: TESTIMONIAL_DATA,
    },
  ],
};
